import { render, staticRenderFns } from "./searchSelect.vue?vue&type=template&id=b64de2e4&scoped=true"
import script from "./searchSelect.vue?vue&type=script&lang=js"
export * from "./searchSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64de2e4",
  null
  
)

export default component.exports